module.exports = __webpack_public_path__ + "static/media/red02.ae943861.svg";